$(document).ready(function () {
  
  var galleryCheck = $("div.gallery_uf").length;
  
  console.log(galleryCheck);
  extensions = ["_pico.",
                "_icon.",
                "_thumb.",
                "_small.",
                "_compact.",
                "_medium.",
                "_large.",
                "_grande.",
                "_1024x1024.",
                "_2048x2048."
                ];
  
  if (galleryCheck > 0) {
    
    gallery = $("div.gallery_uf");
    gallery.css('text-align','center');
    var images = gallery.find('img');
    
    images.each(function () {
      
      	imgSRC = $(this).attr('src');
      
      for ( var i = 0; i < extensions.length; i++){
        //alert('extensions['+i+'] is: ' + extensions[i]);
        var newSRC = imgSRC.replace( exensions[i] ,'.');
        
        if (newSRC.length<imgSRC.length) {break };
        //imgSRC = $(this).attr('src','newSRC')';
      }
      
      $(this).wrap('<a href="' + newSRC + '" data-lightbox="gallery"></a>');
    });
  };
  
});